<template>
    <div class="checkbox-input">
        <input type="hidden" :name="`${name}_del`" value="on" v-if="separateDelete">
        <label class="checkbox-input__wrapper">
            <input
                class="checkbox-input__input"
                type="checkbox"
                :name="name"
                :value="value"
                :checked="checked"
                :disabled="disabled"
                @change="onChange"
            >
            <span class="checkbox-input__label">
                {{ label }}
                <slot></slot>
            </span>
        </label>
        <span class="checkbox-input__message">{{ status }}</span>
    </div>
</template>

<script>
export default {
    name: 'checkbox-input',

    model: {
        prop: 'checked',
        event: 'change',
    },

    props: {
        name: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        },
        status: {
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        value: {
            default: 'on',
        },
        checked: {
            default: false,
        },
        separateDelete: {
            default: true,
        },
    },

    methods: {
        onChange(e) {
            this.$emit('change', e.target.checked);
        },
    },
};
</script>
